// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3wymZ","name":"ConsentHeader_name__3wzna","birthday":"ConsentHeader_birthday__39n4j","skeleton":"ConsentHeader_skeleton___-0pR"};